import React from 'react'
import "./ourbusiness.css";
import { Building2, Home, Hammer, DollarSign } from "lucide-react";
const services = [
  {
    id: 1,
    icon: <Home size={40} />,
    title: "Valuation",
    description:
      "Unlock the value in every dimension of your property with integrated, data-led services that support your overall real estate strategy.",
  },
  {
    id: 2,
    icon: <Building2 size={40} />,
    title: "Agency",
    description:
      "Our team’s expertise and insights from clients and partners enable us to curate customized listings that realize potential in every business transaction.",
  },
  {
    id: 3,
    icon: <Hammer size={40} />,
    title: "Property Management",
    description:
      "We guarantee value and growth through our professional management of properties and real estate portfolios.",
  },
  {
    id: 4,
    icon: <DollarSign size={40} />,
    title: "Property Development",
    description: (
      <>
        <p>
          Empowering clients to allocate capital and space wisely, prioritize
          projects, and eliminate waste in capital spending.
        </p>
        <ul>
          <li>Get specialized advice and find investment opportunities</li>
          <li>Plan, design & build transformational spaces</li>
          <li>Transform business outcomes</li>
        </ul>
      </>
    ),
  },
  {
    id: 5,
    icon: <DollarSign size={40} />,
    title: "Development & Rent Finance Brokerage",
    description:
      "Uncover hidden potential and maximize portfolio value through innovative, data-driven end-to-end real estate solutions.",
  },
];
const OurBusiness = () => {
  return (
    <div className='businesscontainer'>
         <h1 className="business-txt">OUR BUSINESS</h1>
         <article className='top-art'>
            <p className='top-para'>
                EAEC offers Property Valuation, commercial brokerage, retail leasing and management, Property development Finance brokerage, research, advisory, asset management, project management, facilities management, and other corporate real estate services in Nigeria.
            </p>
            <p className='top-para'>
     EAEC is registered with the Estate Surveyors and Valuers Registration Board of Nigeria (ESVARBON) and enjoys association with the Nigerian Institution of Estate Surveyors and Valuers (NIESV). These associations provide EAEC with the added ability to give our clients the comfort of knowing that job’s execution on its behalf will be carried out in an ethical manner, and in line with international standards and best practices kept firmly in view. We are a boutique firm who understand that one size doesn’t always fit all well and so using our insights and data that span every dimension of the industry we create tailor made Real Estate solutions for clients who choose us our services.
            </p>
            </article>
        <section className="services-section">
      <div className="services-header">
        <h2>Our Services</h2>
        <p>
          Comprehensive real estate solutions tailored to help you make smarter
          property decisions, build better spaces, and unlock hidden value.
        </p>
      </div>

      <div className="services-grid">
        {services.map((service) => (
          <div className="service-card" key={service.id}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <div className="service-description">{service.description}</div>
          </div>
        ))}
      </div>
    </section>
    </div>
  )
}

export default OurBusiness